export default "__VITE_ASSET__BWncLjsC__"